<style lang="scss" scoped="scoped">
::-webkit-scrollbar {
	display: none;
}
</style>
<style lang="scss"></style>
<template>
	<div style="width: 100%;padding-bottom: 40px;">
		<div class="titleBar" style="display: flex;margin-top: 20px;align-items:center ;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #303133;">
				{{ $t('ziduanpeizhi') }}
			</p>
		</div>
		<div style="display: flex;width: 100%;justify-content: center;height: 320px;margin-top: 20px;">
			<el-transfer target-order="push" style="text-align: left; display: inline-block" v-model="monitorSetting.MONITOR_PRODUCTION_SCHEDULE_CONFIG_COLUMNS" :titles="[$t('yincanglie'), $t('xianshilie')]"
                   :format="{noChecked: '${total}',hasChecked: '${checked}/${total}'}" @change="showColumnsChange" :data="allColumns">
				<div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;">
					<div>{{ $t(option.label) }}</div>
					<div>
					</div>
				</div>
			</el-transfer>
		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	name: 'web_jschicheng_monitor_production_schedule_config_setting',
	components: {

	},

	data() {
		return {
			monitorSetting: {},
			allColumns: [
        {
          key: 'shengchangongdanhao',
          label: this.$t('shengchangongdanhao'),
          disabled: true,
        },
        {
          key: 'shebeibianhao',
          label: this.$t('shebeibianhao'),
          disabled: true,
        },
        {
          key: 'chanpinmingcheng',
          label: this.$t('chanpinmingcheng'),
          disabled: false,
        },
        {
          key: 'banchanmo',
          label: this.$t('banchanmo'),
          disabled: false,
        },
        {
          key: 'banchanyongliao',
          label: this.$t('banchanyongliao'),
          disabled: false,
        },
        {
          key: 'dingdanyongliao',
          label: this.$t('dingdanyongliao'),
          disabled: false,
        },
        {
          key: 'zongjihuashuliang',
          label: this.$t('zongjihuashuliang'),
          disabled: false,
        },
        {
          key: 'shengyumoshu',
          label: this.$t('shengyumoshu'),
          disabled: false,
        },
        {
          key: 'yishengchanshuliang',
          label: this.$t('yishengchanshuliang'),
          disabled: false,
        },
        {
          key: 'dingdanjiaofuriqi',
          label: this.$t('dingdanjiaofuriqi'),
          disabled: false,
        },
        {
          key: 'zaobanrenyuan',
          label: this.$t('zaobanrenyuan'),
          disabled: false,
        },
        {
          key: 'wanbanrenyuan',
          label: this.$t('wanbanrenyuan'),
          disabled: false,
        },
        {
          key: 'daishengchandingdan',
          label: this.$t('daishengchandingdan'),
          disabled: false,
        },
        {
          key: 'zhuyishixiangguanzhu',
          label: this.$t('zhuyishixiangguanzhu'),
          disabled: false,
        },
        {
          key: 'beizhu',
          label: this.$t('beizhu'),
          disabled: false,
        },
        {
          key: 'chanpinwendingzhouqi',
          label: this.$t('chanpinwendingzhouqi'),
          disabled: false,
        },
        {
          key: 'zonghebulianglv',
          label: this.$t('zonghebulianglv'),
          disabled: false,
        },
        {
          key: 'dangtianbulianglv',
          label: this.$t('dangtianbulianglv'),
          disabled: false,
        },
			]
		};
	},
	created() {
		this.resetData()
	},
	activated() {
		this.resize()
	},
	mounted() {
		this.resize()
		this.utils.event_hub.$on('RESIZE', () => {
			this.resize();
		});
	},
	destroyed() { },
	methods: {
		showColumnsChange(e) {
      //如果有备注，把备注放最后
			console.log(e)
			let index = e.indexOf('beizhu')
			if (index > 0) {
				e.splice(index, 1)
				e.push('beizhu')
			}
		},
		resetData() {
			//可能要防到mainjs里面去初始化,因为看板拿配置的时候setting弹框还没打开
			let monitorSetting = localStorage.getItem("MONITOR_SETTING")
			if (!monitorSetting) {
				this.monitorSetting = {}
			} else {
				this.monitorSetting = JSON.parse(monitorSetting)
			}

			this.monitorSetting.MONITOR_PRODUCTION_SCHEDULE_CONFIG_COLUMNS = this.monitorSetting.MONITOR_PRODUCTION_SCHEDULE_CONFIG_COLUMNS !=
				null ?
				this.monitorSetting.MONITOR_PRODUCTION_SCHEDULE_CONFIG_COLUMNS : ['shengchangongdanhao','shebeibianhao','chanpinmingcheng',
            'banchanmo','banchanyongliao','dingdanyongliao','zongjihuashuliang','shengyumoshu','yishengchanshuliang',
            'dingdanjiaofuriqi','zaobanrenyuan','wanbanrenyuan','daishengchandingdan','zhuyishixiangguanzhu','beizhu','chanpinwendingzhouqi','zonghebulianglv','dangtianbulianglv'
				]

			localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting))

		},
		resize() {
			//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
			setTimeout(() => {
			}, 500)
		},
		save() {
			localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting))
			//首次进入的时候row可能还没出来，这时候emit row还没on，所以没有触发，这里加一个nextTick
			this.utils.event_hub.$emit('setScheduleConfigMonitor')
		}

	}
};
</script>
